import { Controller } from "@hotwired/stimulus"

// Manages tab-panel visibility in the agents gallery.
// Works alongside Ui::TabsComponent's built-in tab switching.
export default class extends Controller {
  static targets = ["panel"]

  connect() {
    // Nothing needed - Ui::TabsComponent handles tab switching via ui--tabs controller
  }
}
